<fieldset [formGroup]="standardFunctionalElementGroup" *ngIf="visible$ | async">
    <ng-container *ngrxLet="standardFunctionalElement$; let standardFunctionalElement">
        <div class="row">
            <p class="col-sm-10 col-12" [innerHTML]="standardFunctionalElement.label"></p>
            <span class="col-sm-2 col-12 text-end filter-text">{{ elementTypeLabel$ | async }}</span>
        </div>

        <pace-forms-choices
            [choices]="choices$ | async"
            *ngIf="standardFunctionalElement.choices"
            [formControl]="radioControl"
        ></pace-forms-choices>

        <pace-forms-input-text
            [id]="standardFunctionalElement.xmlId"
            [label]="standardFunctionalElement.remarksLabel"
            [formControl]="remarksControl"
            *ngIf="showRemarksField$ | async"
        ></pace-forms-input-text>
    </ng-container>
</fieldset>
